import React from "react";
import LogoImg from "../../assets/img/new-logo-LLC.png";

function GlobalLogoLLC({logoClass}) {
  return (
    <div className={logoClass}>
      <img src={LogoImg} alt="surya-logo-llc" />
    </div>
  );
}

export default GlobalLogoLLC;
